/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

function _window(): any {
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class WindowRefService {
  private _doc = inject<Document>(DOCUMENT);

  get nativeWindow(): any {
    if (typeof window !== 'undefined') {
      return _window();
    }
    return null;
  }
}